import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "react-bootstrap";
import SearchBar from "./searchBar";
import { useEffect, useState } from "react";
import { ref, push, onValue, remove, update } from "firebase/database";
import { database } from "./firebase";
import DataTable from "react-data-table-component";
import TableStyleCard from "./tableStyleCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisH,
  faFileEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

const Categories = () => {
  const [showModal, setShowModal] = useState(false);
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [newCategory, setNewCategory] = useState("");
  const [editId, setEditId] = useState(null);

  /* ================= ADD / UPDATE ================= */
  const setCategory = async (e) => {
    e.preventDefault();
    if (!newCategory.trim()) return;

    try {
      if (editId) {
        await update(ref(database, `/helpdesk/categories/${editId}`), {
          name: newCategory,
        });
        setEditId(null);
      } else {
        await push(ref(database, "/helpdesk/categories"), {
          name: newCategory,
          createdAt: new Date().toISOString(),
        });
      }

      setNewCategory("");
      setShowModal(false);
    } catch (error) {
      console.error("Error saving category:", error);
    }
  };

  /* ================= REALTIME LISTENER ================= */
  useEffect(() => {
    const catRef = ref(database, "/helpdesk/categories");
    const unsubscribe = onValue(catRef, (snapshot) => {
      const data = snapshot.val();
      const list = data
        ? Object.entries(data).map(([id, value]) => ({
            id,
            ...value,
          }))
        : [];
      setCategories(list);
    });

    return () => unsubscribe();
  }, []);

  /* ================= DELETE ================= */
  const deleteCategory = async (id) => {
    try {
      await remove(ref(database, `/helpdesk/categories/${id}`));
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  /* ================= EDIT ================= */
  const startEdit = (cat) => {
    setEditId(cat.id);
    setNewCategory(cat.name);
    setShowModal(true);
  };

  /* ================= SEARCH ================= */
  const handleSearch = (term) => {
    setSearchTerm(term.toLowerCase());
  };

  const filteredCategories = categories.filter((cat) =>
    cat.name?.toLowerCase().includes(searchTerm)
  );

  /* ================= TABLE ================= */
  const columns = [
    {
      name: "Name",
      cell: (row) => <span className="py-2 h6 text-gray-800">{row.name}</span>,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="dropdown">
          <button className="btn btn-round shadow-sm" data-toggle="dropdown">
            <FontAwesomeIcon icon={faEllipsisH} />
          </button>

          <div className="dropdown-menu dropdown-menu-right border-0 shadow-lg">
            <button className="dropdown-item" onClick={() => startEdit(row)}>
              <FontAwesomeIcon
                className="text-gray-300 mr-2"
                icon={faFileEdit}
              />
              Edit
            </button>

            <div className="dropdown-divider"></div>

            <button
              className="dropdown-item text-danger"
              onClick={() => deleteCategory(row.id)}
            >
              <FontAwesomeIcon className="text-gray-300 mr-2" icon={faTrash} />
              Delete
            </button>
          </div>
        </div>
      ),
      width: "80px",
    },
  ];

  /* ================= RENDER ================= */
  return (
    <>
      <div className="card mt-4 shadow">
        <div className="card-header bg-white py-2 d-flex align-items-center">
          <div className="d-flex w-100">
            <SearchBar onSearch={handleSearch} />

            <button
              className="btn btn-lg btn-primary ml-auto"
              onClick={() => {
                setEditId(null);
                setShowModal(true);
              }}
            >
              Add
            </button>
          </div>
        </div>
      </div>

      <div className="p-2" style={{ background: "#E1E3F0" }}>
        <DataTable
          customStyles={TableStyleCard}
          columns={columns}
          data={filteredCategories}
          pagination
          noTableHead
          highlightOnHover
          dense
        />
      </div>

      {/* MODAL */}
      <Modal show={showModal}>
        <ModalHeader>
          <ModalTitle>{editId ? "Edit Category" : "Add Category"}</ModalTitle>
          <button className="btn btn-round" onClick={() => setShowModal(false)}>
            <span className="material-icons">close</span>
          </button>
        </ModalHeader>

        <ModalBody>
          <form onSubmit={setCategory}>
            <input
              className="form-control"
              placeholder="Enter category name"
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)}
              required
            />
          </form>
        </ModalBody>

        <ModalFooter>
          <button className="btn btn-primary" onClick={setCategory}>
            {editId ? "Update" : "Submit"}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Categories;
